import { render, staticRenderFns } from "./ed-add-paper-write-object.vue?vue&type=template&id=5f9d4d4a&scoped=true&"
import script from "./ed-add-paper-write-object.ts?vue&type=script&lang=ts&"
export * from "./ed-add-paper-write-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-add-paper-write-object.scss?vue&type=style&index=0&id=5f9d4d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9d4d4a",
  null
  
)

export default component.exports